/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { VISIT_STATUS } from "apis/visitors/type";
import { theme } from "styles/theme";
import Select_V2 from "uis/Select/select_v2";

const TagContainer = styled.div<{ color?: string; backgroundColor?: string }>`
    width: max-content;
    width: 82px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => props.backgroundColor};
    color: ${(props) => props.color};
    font-size: 14px;
    font-weight: 500;
    border-radius: 30px;
`;

const SendStateTag = ({ state = false }: { state?: boolean }) => {
    return (
        <TagContainer color={state ? theme.primary500 : "#FF3E3E"} backgroundColor={state ? theme.primary50 : "#FFF2F2"}>
            {state ? "전송 완료" : "전송 실패"}
        </TagContainer>
    );
};

export default SendStateTag;
